/**
 * Created by Amit panghal
 */
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";

export class DirtyWildsBitMap extends PIXI.BitmapText {

    private _config:BitmapTextStyleOptions;

    constructor(text:string, config:BitmapTextStyleOptions) {
        super(text, {
            fontName:config.font.name!,
            fontSize:config.font.size,
            align:config.align,
            tint:config.tint || 0xffffff
        });
        this._config = config;
    }

    public updatePosition(maxTextWidth:number, startFontSize?:number) {
        if(startFontSize) {
            this.fontSize = startFontSize;
            this.updateTransform();
        }

        while(this.width > maxTextWidth) {
            this.fontSize--;
            this.updateTransform();
        }
    }

    public reset():void {
       this.fontSize = this._config.font.size!;
    }
}